var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <button class="nfd-btn-gold nfd-btn-gold-default"type="button"data-bind="click: onClick, css: btnClasses, enable: enable"><!-- ko if: iconClass --> <i class="nfd-icon nfd-btn-gold-icon"data-bind="css: iconClass"> </i><!-- /ko --> <span class="nfd-btn-gold-content"><!-- ko if: content --> <span data-bind="html: content"></span><!-- /ko --> <!-- ko template: { nodes: $componentTemplateNodes, data: $parent } --><!-- /ko --> </span> </button> <!-- /ko -->';
}
return __p;
};
